import { gql } from "lib/apolloClient";

export const manageUserMfaMutation = gql`
  mutation manageUserMfa($input: ManageUserMfaInput!) {
    platform {
      manageUserMfa(input: $input) {
        isSuccess
        message
      }
    }
  }
`;

export const upsertMfaPoliciesMutation = gql`
  mutation upsertMfaPolicies($input: [UpsertMfaPoliciesInput!]!) {
    organizationManagement {
      upsertMfaPolicies(input: $input) {
        isSuccess
        message
        mfaPolicies {
          entityType
          entityValue
          isEnabled
          isEnforced
          enforcementDeadline
          defaultGracePeriod
          allowedMfaMethods
          allowBackupCodes
        }
      }
    }
  }
`;

export const initiateMfaSetupMutation = gql`
  mutation initiateMfaSetup($input: InitiateMfaSetupInput!) {
    platform {
      initiateMfaSetup(input: $input) {
        isSuccess
        totpAuthUri
        message
        setupKey
        backupCodes
        email
        regenOTPTime
      }
    }
  }
`;

export const completeUserMfaMutation = gql`
  mutation completeMfaSetup($input: CompleteMfaSetupInput!) {
    platform {
      completeMfaSetup(input: $input) {
        isSuccess
        message
      }
    }
  }
`;

export const disconnectUserMfaMutation = gql`
  mutation disconnectUserMfa($input: DisconnectUserMfaInput!) {
    platform {
      disconnectUserMfa(input: $input) {
        isSuccess
        message
      }
    }
  }
`;

export const verifyUserMfaMutation = gql`
  mutation verifyUserMfa($input: VerifyUserMfaInput!) {
    platform {
      verifyUserMfa(input: $input) {
        isSuccess
        message
        jwt
      }
    }
  }
`;

export const togglePrimaryMfaMethodMutation = gql`
  mutation togglePrimaryMfaMethod($input: TogglePrimaryMfaMethodInput!) {
    platform {
      togglePrimaryMfaMethod(input: $input) {
        isSuccess
        message
      }
    }
  }
`;

export const sendOtpForMfaVerificationMutation = gql`
  mutation sendOtpForMfaVerification($input: SendOtpForMfaVerificationInput!) {
    platform {
      sendOtpForMfaVerification(input: $input) {
        isSuccess
        message
        regenOTPTime
      }
    }
  }
`;
